export const METRIC_AGGREGATIONS = [
  { value: "SUM", label: "SUM", description: "Total of numeric values" },
  { value: "AVG", label: "AVG", description: "Mean across rows" },
  { value: "COUNT", label: "COUNT", description: "Row count" },
  { value: "COUNT_DISTINCT", label: "COUNT DISTINCT", description: "Unique values" },
  { value: "MIN", label: "MIN", description: "Minimum value" },
  { value: "MAX", label: "MAX", description: "Maximum value" },
  { value: "STDDEV", label: "STDDEV", description: "Standard deviation" },
  { value: "PERCENTILE", label: "PERCENTILE", description: "Percentile (p50 default)" },
];

export const METRIC_SOURCE_TYPES = [
  { value: "field", label: "Dataset field" },
  { value: "expression", label: "Custom expression" },
];

export const METRIC_FORMATS = [
  { value: "auto", label: "Auto" },
  { value: "integer", label: "Integer" },
  { value: "decimal", label: "Decimal (2)" },
  { value: "percent", label: "Percent" },
  { value: "currency", label: "Currency (₹)" },
  { value: "compact", label: "Compact (1.2K)" },
];

export const METRIC_FILTER_OPS = [
  { value: "=", label: "=" },
  { value: "!=", label: "≠" },
  { value: ">", label: ">" },
  { value: ">=", label: "≥" },
  { value: "<", label: "<" },
  { value: "<=", label: "≤" },
  { value: "null", label: "is null" },
  { value: "notNull", label: "is not null" },
];

/** Quick-add presets — applied via store.addMetricFromPreset */
export const METRIC_PRESETS = [
  { id: "total-distance", label: "Total distance", agg: "SUM", field: "distance_km", alias: "total_distance_km", format: "decimal" },
  { id: "avg-speed", label: "Avg speed", agg: "AVG", field: "speed", alias: "avg_speed", format: "decimal" },
  { id: "fuel-used", label: "Fuel consumed", agg: "SUM", field: "fuel_used", alias: "total_fuel_used", format: "decimal" },
  { id: "trip-count", label: "Trip count", agg: "COUNT_DISTINCT", field: "trip_id", alias: "trip_count", format: "integer" },
  { id: "active-vehicles", label: "Active vehicles", agg: "COUNT_DISTINCT", field: "vehicle_id", alias: "active_vehicles", format: "integer" },
  {
    id: "fuel-efficiency",
    label: "Fuel efficiency",
    sourceType: "expression",
    expression: "distance_km / NULLIF(fuel_used, 0)",
    agg: "AVG",
    alias: "km_per_liter",
    format: "decimal",
  },
];

export const FILTER_OPERATORS = [
  { value: "eq", label: "=" },
  { value: "neq", label: "≠" },
  { value: "gt", label: ">" },
  { value: "lt", label: "<" },
  { value: "between", label: "between" },
  { value: "contains", label: "contains" },
  { value: "in", label: "in" },
];

export const VISUALIZATION_TYPES = [
  { id: "table", label: "Table", description: "Sortable grid with export" },
  { id: "bar", label: "Bar chart", description: "Compare categories" },
  { id: "line", label: "Line chart", description: "Trends over time" },
  { id: "pie", label: "Pie chart", description: "Share of total" },
  { id: "map", label: "Map", description: "Geographic heatmap" },
];

export const FORMULA_HINTS = ["+", "−", "×", "÷", "()", "IF", "CASE", "ROUND", "SUM", "AVG"];

export const REPORT_STEPS = [
  { id: "dataset", label: "Dataset", description: "Choose the telemetry source to query" },
  { id: "filters", label: "Filters", description: "Narrow rows before aggregation" },
  { id: "sessions", label: "Sessions", description: "Define trip or ignition boundaries" },
  { id: "fields", label: "Fields", description: "Add calculated columns with WHEN/THEN logic" },
  { id: "grouping", label: "Grouping", description: "Optional dimensions for roll-up (not required)" },
  { id: "metrics", label: "Metrics", description: "Customize aggregations, aliases, and formats" },
  { id: "visual", label: "Visual", description: "Chart or table output" },
  { id: "save", label: "Save", description: "Name and persist the report" },
];
